var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"all-com"},[_c('div',{staticStyle:{"background-color":"white"}},[_c('el-tree',{ref:"tree",attrs:{"data":_vm.groups,"node-key":"sid","props":_vm.props,"show-checkbox":"","default-expand-all":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }